import type {
  CreateAlunoUseCase,
  GetAlunoUseCase,
  ListAlunosUseCase,
  UpdateAlunoUseCase,
} from '@/application/port/in/AlunoUseCase';
import type {
  CreateAlunoCommand,
  ListAlunosQuery,
  UpdateAlunoCommand,
} from '@/application/port/in/dto/AlunoCommand';
import type { AlunoGateway } from '@/application/port/out/AlunoGateway';
import type { Aluno } from '@/domain/model/Aluno';
import type { Page } from '@/domain/model/Page';

export class ListAlunosUseCaseImpl implements ListAlunosUseCase {
  constructor(private readonly gateway: AlunoGateway) {}
  execute(query: ListAlunosQuery): Promise<Page<Aluno>> {
    return this.gateway.list(query);
  }
}

export class GetAlunoUseCaseImpl implements GetAlunoUseCase {
  constructor(private readonly gateway: AlunoGateway) {}
  execute(id: string): Promise<Aluno> {
    if (!id) return Promise.reject(new Error('ID do aluno é obrigatório'));
    return this.gateway.getById(id);
  }
}

export class CreateAlunoUseCaseImpl implements CreateAlunoUseCase {
  constructor(private readonly gateway: AlunoGateway) {}
  execute(command: CreateAlunoCommand): Promise<Aluno> {
    return this.gateway.create(command);
  }
}

export class UpdateAlunoUseCaseImpl implements UpdateAlunoUseCase {
  constructor(private readonly gateway: AlunoGateway) {}
  execute(id: string, command: UpdateAlunoCommand): Promise<Aluno> {
    if (!id) return Promise.reject(new Error('ID do aluno é obrigatório'));
    return this.gateway.update(id, command);
  }
}
